import React from 'react';
import { ChartingCodeProvider } from './lib/chartingCodeContext';
import { Grid } from '@mui/material';
import ChartingCodeDebug from './ChartingCodeDebug';
import CodeLayoutTypeSelector from './CodeRenderers/CodeLayoutTypeSelector';



export const CodeRenderer = ({ codeConfig }) => {

	return (
		<ChartingCodeProvider codeConfig={codeConfig}>
			<Grid container spacing={3}>
				<Grid size={{ xs: 'auto' }}>
					<CodeLayoutTypeSelector template={codeConfig} />
				</Grid>

				<Grid size={{ xs: true }}>
					<ChartingCodeDebug template={codeConfig} />
				</Grid>
			</Grid>

		</ChartingCodeProvider>
	);
};

export default CodeRenderer;
